import { Box, Theme } from '@mui/material';

export const Background = () => {
  return (
    <Box
      sx={(theme: Theme) => ({
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        minHeight: '100%',
        background: ({ palette }) => palette.background.main,
        zIndex: '-1',
        ...theme.applyStyles('dark', {
          background: theme.palette.background.gradient,
        }),
      })}
    />
  );
};

export const PagePadding = {
  TABLE_LIST_PAGE: { xs: '20px 8px 24px 8px', sm: '40px 24px 24px 24px' },
};
